<div class="wrapper" *ngIf="storageService.view_modules">
  <div
    [ngClass]="{
      'animate__animated animate__fadeOut out-content ': storageService.expandsView
    }"
  >
    <app-header class="topnavbar-wrapper"></app-header>
    <app-sidebar class="aside-container"></app-sidebar>
    <app-offsidebar class="offsidebar"></app-offsidebar>
  </div>

  <section
    [class]="!storageService.expandsView ? 'section-container' : ''"
    [ngClass]="{
      'margin-client': !storageService.validateSoloAdmin() || storageService.localValue.mode === 1
    }"
  >
    <div
      [class]="
        !storageService.expandsView
          ? 'content-wrapper animate__animated animate__fadeIn'
          : 'content-expand '
      "
    >
      <div style="min-height: 80vh">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-modals></app-modals>
  </section>
</div>
